// extracted by mini-css-extract-plugin
export default {"cardHeader":"CardHeader_cardHeader__BMSHf","title":"CardHeader_title__wipuO","subtitle":"CardHeader_subtitle__adwUi","meta":"CardHeader_meta__dvW7H"};